import { computed, Injectable, signal } from '@angular/core';
import { Menu, MenuMobile, PageTitle } from 'src/utils/models/layout.interface';
import { ModuleConfig, MODULES_CONFIG } from './module.config';
import navigation from 'src/utils/constants/layout/navigation.json';

const STORAGE_KEY = 'activeModuleId';

@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  readonly modules = signal<ModuleConfig[]>(MODULES_CONFIG);

  private readonly _activeModuleId = signal<string | null>(
    localStorage.getItem(STORAGE_KEY)
  );

  readonly activeModuleId = this._activeModuleId.asReadonly();

  readonly activeModule = computed<ModuleConfig | undefined>(() =>
    this.modules().find((m) => m.id === this._activeModuleId())
  );

  readonly hasModuleSelected = computed<boolean>(() => true);

  readonly activeMenus = computed<Menu[]>(() => navigation.menus as Menu[]);

  readonly activePageTitles = computed<PageTitle[]>(() => navigation.titles as PageTitle[]);

  readonly activeMenusMobile = computed<MenuMobile>(() => navigation.menusMobile as MenuMobile);

  selectModule(moduleId: string): void {
    this._activeModuleId.set(moduleId);
    localStorage.setItem(STORAGE_KEY, moduleId);
  }

  clearModule(): void {
    this._activeModuleId.set(null);
    localStorage.removeItem(STORAGE_KEY);
  }
}
